const subject_icons = {
  biology: require("../assets/subject-icons/biology.svg"),
  physics: require("../assets/subject-icons/physics.svg"),
  maths: require("../assets/subject-icons/maths.svg"),
  social: require("../assets/subject-icons/social.svg"),
  english: require("../assets/subject-icons/english.svg"),
  chemistry: require("../assets/subject-icons/chemistry.svg"),
  bialogyMobile: require("../assets/svgs/bialogyMobile.svg"),
  physicsMobile: require("../assets/svgs/physicsMobile.svg"),
  mathsMobile: require("../assets/svgs/mathsMobile.svg"),
  chemistryMobile: require("../assets/svgs/chemistryMobile.svg"),
  englishMobile: require("../assets/svgs/englishMobile.svg"),
  socialMobile: require("../assets/svgs/socialMobile.svg"),
  gpMobile: require("../assets/svgs/gp.svg"),
};

export default subject_icons;
